import MultiStyleText from "pixi-multistyle-text/dist/pixi-multistyle-text";
import * as PIXI from "pixi.js";

/**
 * Added a new Style `lineSpace (number)`
 * Added default <u></u> tag, for underline the text
 */
export class CustomMultiStyleText extends MultiStyleText {
  constructor(text, styles){
    super(text, {
      "u": {}, // register underline tag by default
      ...styles,
    })
  }

  updateText(){
    /**************** COPIED AND MODIFIED FROM pixi-multistyle-text.js ****************************/
    var _this = this;
    if (!this.dirty) {
      return;
    }
    this.texture.baseTexture.resolution = this.resolution;
    var textStyles = this.textStyles;
    var outputText = this.text;
    if (this._style.wordWrap) {
      outputText = this.wordWrap(this.text);
    }
    var lines = outputText.split(/(?:\r\n|\r|\n)/);
    var outputTextData = this._getTextDataPerLine(lines);
    var lineWidths = [];
    var lineYMins = [];
    var lineYMaxs = [];
    var baselines = [];
    var maxLineWidth = 0;
    for (var i = 0; i < lines.length; i++) {
      var lineWidth = 0;
      var lineYMin = 0;
      var lineYMax = 0;
      var baseline = 0;
      for (var j = 0; j < outputTextData[i].length; j++) {
        var sty = outputTextData[i][j].style;
        this.context.font = this.getFontString(sty);
        outputTextData[i][j].width = this.context.measureText(outputTextData[i][j].text).width;
        if (outputTextData[i][j].text.length === 0) {
          outputTextData[i][j].width += (outputTextData[i][j].text.length - 1) * sty.letterSpacing;
          if (j > 0) {
            lineWidth += sty.letterSpacing / 2;
          }
          if (j < outputTextData[i].length - 1) {
            lineWidth += sty.letterSpacing / 2;
          }
        }
        lineWidth += outputTextData[i][j].width;
        outputTextData[i][j].fontProperties = PIXI.TextMetrics.measureFont(this.context.font);
        outputTextData[i][j].height =
          outputTextData[i][j].fontProperties.fontSize + outputTextData[i][j].style.strokeThickness;
        if (typeof sty.valign === "number") {
          lineYMin = Math.min(lineYMin, sty.valign - outputTextData[i][j].fontProperties.descent);
          lineYMax = Math.max(lineYMax, sty.valign + outputTextData[i][j].fontProperties.ascent);
        }
        else {
          lineYMin = Math.min(lineYMin, -outputTextData[i][j].fontProperties.descent);
          lineYMax = Math.max(lineYMax, outputTextData[i][j].fontProperties.ascent);
        }
      }
      lineWidths[i] = lineWidth;
      lineYMins[i] = lineYMin;
      lineYMaxs[i] = lineYMax;
      maxLineWidth = Math.max(maxLineWidth, lineWidth);
    }
    var stylesArray = Object.keys(textStyles).map(function (key) { return textStyles[key]; });
    var maxStrokeThickness = stylesArray.reduce(function (prev, cur) { return Math.max(prev, cur.strokeThickness || 0); }, 0);
    var maxLineSpace = stylesArray.reduce(function (prev, cur) { return Math.max(prev, cur.lineSpace || 1); }, 1);

    var dropShadowPadding = this.getDropShadowPadding();
    var totalHeight = lineYMaxs.reduce(function (prev, cur) { return prev + cur; }, 0) - lineYMins.reduce(function (prev, cur) { return prev + cur; }, 0);
    var width = maxLineWidth + maxStrokeThickness + 2 * dropShadowPadding;
    var height = (totalHeight + 2 * dropShadowPadding) * maxLineSpace;
    this.canvas.width = (width + this.context.lineWidth) * this.resolution;
    this.canvas.height = height * this.resolution;
    this.context.scale(this.resolution, this.resolution);
    this.context.textBaseline = "alphabetic";
    this.context.lineJoin = "round";
    var basePositionY = dropShadowPadding;
    var drawingData = [];
    for (var i = 0; i < outputTextData.length; i++) {
      var line = outputTextData[i];
      var linePositionX = void 0;
      switch (this._style.align) {
        case "left":
          linePositionX = dropShadowPadding;
          break;
        case "center":
          linePositionX = dropShadowPadding + (maxLineWidth - lineWidths[i]) / 2;
          break;
        case "right":
          linePositionX = dropShadowPadding + maxLineWidth - lineWidths[i];
          break;
      }
      for (var j = 0; j < line.length; j++) {
        var _a = line[j], style = _a.style, text = _a.text, fontProperties = _a.fontProperties, width_1 = _a.width, height_1 = _a.height, tagName = _a.tagName;
        linePositionX += maxStrokeThickness / 2;
        var linePositionY = maxStrokeThickness / 2 + basePositionY + fontProperties.ascent;
        switch (style.valign) {
          case "top":
            break;
          case "baseline":
            linePositionY += lineYMaxs[i] - fontProperties.ascent;
            break;
          case "middle":
            linePositionY += (lineYMaxs[i] - lineYMins[i] - fontProperties.ascent - fontProperties.descent) / 2;
            break;
          case "bottom":
            linePositionY += lineYMaxs[i] - lineYMins[i] - fontProperties.ascent - fontProperties.descent;
            break;
          default:
            linePositionY += lineYMaxs[i] - fontProperties.ascent - style.valign;
            break;
        }
        if (style.letterSpacing === 0) {
          drawingData.push({
            text: text,
            style: style,
            x: linePositionX,
            y: linePositionY * maxLineSpace,
            width: width_1,
            ascent: fontProperties.ascent,
            descent: fontProperties.descent,
            tagName: tagName
          });
          linePositionX += line[j].width;
        }
        else {
          this.context.font = this.getFontString(line[j].style);
          for (var k = 0; k < text.length; k++) {
            if (k > 0 || j > 0) {
              linePositionX += style.letterSpacing / 2;
            }
            drawingData.push({
              text: text.charAt(k),
              style: style,
              x: linePositionX,
              y: linePositionY * maxLineSpace,
              width: width_1,
              ascent: fontProperties.ascent,
              descent: fontProperties.descent,
              tagName: tagName
            });
            linePositionX += this.context.measureText(text.charAt(k)).width;
            if (k < text.length - 1 || j < line.length - 1) {
              linePositionX += style.letterSpacing / 2;
            }
          }
        }
        linePositionX -= maxStrokeThickness / 2;
      }
      basePositionY += lineYMaxs[i] - lineYMins[i];
    }
    this.context.save();
    drawingData.forEach(function (_a) {
      var style = _a.style, text = _a.text, x = _a.x, y = _a.y;
      if (!style.dropShadow) {
        return;
      }
      _this.context.font = _this.getFontString(style);
      var dropFillStyle = style.dropShadowColor;
      if (typeof dropFillStyle === "number") {
        dropFillStyle = PIXI.utils.hex2string(dropFillStyle);
      }
      _this.context.shadowColor = dropFillStyle;
      _this.context.shadowBlur = style.dropShadowBlur;
      _this.context.shadowOffsetX = Math.cos(style.dropShadowAngle) * style.dropShadowDistance * _this.resolution;
      _this.context.shadowOffsetY = Math.sin(style.dropShadowAngle) * style.dropShadowDistance * _this.resolution;
      _this.context.fillText(text, x, y);
    });
    this.context.restore();
    drawingData.forEach(function (_a) {
      var style = _a.style, text = _a.text, x = _a.x, y = _a.y, width = _a.width, ascent = _a.ascent, descent = _a.descent, tagName = _a.tagName;
      _this.context.font = _this.getFontString(style);
      var strokeStyle = style.stroke;
      if (typeof strokeStyle === "number") {
        strokeStyle = PIXI.utils.hex2string(strokeStyle);
      }
      _this.context.strokeStyle = strokeStyle;
      _this.context.lineWidth = style.strokeThickness;

      var fillStyle = style.fill;
      if (typeof fillStyle === "number") {
        fillStyle = PIXI.utils.hex2string(fillStyle);
      }
      else if (Array.isArray(fillStyle)) {
        for (var i = 0; i < fillStyle.length; i++) {
          var fill = fillStyle[i];
          if (typeof fill === "number") {
            fillStyle[i] = PIXI.utils.hex2string(fill);
          }
        }
      }
      _this.context.fillStyle = _this._generateFillStyle(new PIXI.TextStyle(style), [text]);
      if (style.stroke && style.strokeThickness) {
        _this.context.strokeText(text, x, y);
      }
      if (style.fill) {
        _this.context.fillText(text, x, y);
      }
      var debugSpan = style.debug === undefined
        ? MultiStyleText.debugOptions.spans.enabled
        : style.debug;
      if (debugSpan) {
        _this.context.lineWidth = 1;
        if (MultiStyleText.debugOptions.spans.bounding) {
          _this.context.fillStyle = MultiStyleText.debugOptions.spans.bounding;
          _this.context.strokeStyle = MultiStyleText.debugOptions.spans.bounding;
          _this.context.beginPath();
          _this.context.rect(x, y - ascent, width, ascent + descent);
          _this.context.fill();
          _this.context.stroke();
          _this.context.stroke();
        }
        if (MultiStyleText.debugOptions.spans.baseline) {
          _this.context.strokeStyle = MultiStyleText.debugOptions.spans.baseline;
          _this.context.beginPath();
          _this.context.moveTo(x, y);
          _this.context.lineTo(x + width, y);
          _this.context.closePath();
          _this.context.stroke();
        }
        if (MultiStyleText.debugOptions.spans.top) {
          _this.context.strokeStyle = MultiStyleText.debugOptions.spans.top;
          _this.context.beginPath();
          _this.context.moveTo(x, y - ascent);
          _this.context.lineTo(x + width, y - ascent);
          _this.context.closePath();
          _this.context.stroke();
        }
        if (MultiStyleText.debugOptions.spans.bottom) {
          _this.context.strokeStyle = MultiStyleText.debugOptions.spans.bottom;
          _this.context.beginPath();
          _this.context.moveTo(x, y + descent);
          _this.context.lineTo(x + width, y + descent);
          _this.context.closePath();
          _this.context.stroke();
        }
        if (MultiStyleText.debugOptions.spans.text) {
          _this.context.fillStyle = "#ffffff";
          _this.context.strokeStyle = "#000000";
          _this.context.lineWidth = 2;
          _this.context.font = "8px monospace";
          _this.context.strokeText(tagName, x, y - ascent + 8);
          _this.context.fillText(tagName, x, y - ascent + 8);
          _this.context.strokeText(width.toFixed(2) + "x" + (ascent + descent).toFixed(2), x, y - ascent + 16);
          _this.context.fillText(width.toFixed(2) + "x" + (ascent + descent).toFixed(2), x, y - ascent + 16);
        }
      }
    });
    if (MultiStyleText.debugOptions.objects.enabled) {
      if (MultiStyleText.debugOptions.objects.bounding) {
        this.context.fillStyle = MultiStyleText.debugOptions.objects.bounding;
        this.context.beginPath();
        this.context.rect(0, 0, width, height);
        this.context.fill();
      }
      if (MultiStyleText.debugOptions.objects.text) {
        this.context.fillStyle = "#ffffff";
        this.context.strokeStyle = "#000000";
        this.context.lineWidth = 2;
        this.context.font = "8px monospace";
        this.context.strokeText(width.toFixed(2) + "x" + height.toFixed(2), 0, 8, width);
        this.context.fillText(width.toFixed(2) + "x" + height.toFixed(2), 0, 8, width);
      }
    }

    // Custom logic
    // handle underline <u></u>
    drawingData.forEach(function (_a) {
      var style = _a.style, text = _a.text, x = _a.x, y = _a.y, width = _a.width, ascent = _a.ascent, descent = _a.descent, tagName = _a.tagName;
      _this.context.font = _this.getFontString(style);
      var strokeStyle = style.stroke;
      if (typeof strokeStyle === "number") {
        strokeStyle = PIXI.utils.hex2string(strokeStyle);
      }
      _this.context.strokeStyle = strokeStyle;
      _this.context.lineWidth = style.strokeThickness;
      var fillStyle = style.fill;
      if (typeof fillStyle === "number") {
        fillStyle = PIXI.utils.hex2string(fillStyle);
      }
      else if (Array.isArray(fillStyle)) {
        for (var i = 0; i < fillStyle.length; i++) {
          var fill = fillStyle[i];
          if (typeof fill === "number") {
            fillStyle[i] = PIXI.utils.hex2string(fill);
          }
        }
      }
      _this.context.fillStyle = _this._generateFillStyle(new PIXI.TextStyle(style), [text]);
      if (style.stroke && style.strokeThickness) {
        _this.context.strokeText(text, x, y);
      }
      if (style.fill) {
        _this.context.fillText(text, x, y);
      }

      if(tagName === "u"){
        _this.context.strokeStyle = style.stroke;
        _this.context.fillStyle = style.fill;
        _this.context.lineWidth = style.fontSize / 10
        _this.context.rect(x, y + descent, width, style.fontSize / 4);
        _this.context.fill()
        _this.context.stroke();
      }
    });

    // COPIED FROM SOURCE
    this.updateTexture();
  }
}



// WEBPACK FOOTER //
// ./src/game/objects/CustomMultiStyleText.js